<template>
    <div class="filter-min-max">
        <div class="filter-label">
            <input
                type="text"
                class="form-control"
                v-model="value"
                :placeholder="label"
                :name="name"
                :id="inputId"
            />
        </div>
    </div>
</template>
<style lang="scss" scoped>
input {
    background-color: transparent;
    border: transparent;
    outline: none;
    box-shadow: none;
    padding: 0 5px 0 0;
    margin: -7px 0;
}
</style>
<script>
import debounce from "../../../helpers/debounce";

export default {
    name: "textfield",
    props: {
        name: {
            type: String,
            default: "textfield",
        },
        label: {
            type: String,
            default: "",
        },
        currentValue: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            value: "",
        };
    },
    computed: {
        inputId() {
            return `filter-${this.name}`;
        },
    },
    mounted() {
        if (this.currentValue) {
            this.value = this.currentValue;
        }
        if (this.value.length > 0) {
            this.changed();
        }
    },
    methods: {
        changed: debounce(
            function () {
                this.$emit("changed", this.value);
            },
            1000,
            false,
        ),
    },
    watch: {
        value() {
            this.changed();
        },
    },
};
</script>
